import { usePermission } from '@/hooks/usePermission';
import type { Permission } from '@/lib/permissions';

interface Props {
  permission: Permission;
  children: React.ReactNode;
  /** Rendered when the user lacks permission. Defaults to null (hidden). */
  fallback?: React.ReactNode;
}

/**
 * Conditionally renders `children` based on the current user's role.
 *
 * Usage:
 *   <PermissionGate permission="molds:create">
 *     <Button>Add Mold</Button>
 *   </PermissionGate>
 */
export function PermissionGate({ permission, children, fallback = null }: Props) {
  const { can } = usePermission();
  return can(permission) ? <>{children}</> : <>{fallback}</>;
}
